import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import userInformation from './modules/userInformationStore';
import content from './modules/contentStore';
import streamGroup from './modules/streamGroupStore';
import materialStore from './modules/materialStore';

const store = createStore({
  modules: {
    userInformation,
    content,
    streamGroup,
    materialStore,
  },
  mutations: {},
  plugins: [
    createPersistedState({
      key: 'jasignage',
    }),
  ],
});

export default store;
